import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface IWorkSpace {
  [key: string]: any
}

class WorkSpace extends Model<IWorkSpace> {
  static urlRoot() {
    return '/api/rest/space_control/work_space'
  }

  constructor(attr: IWorkSpace) {
    super(attr)

    makeObservable(this, {
      name: computed,
    })
  }

  get id(): number {
    return this.attributes.id
  }

  get name(): string {
    return this.attributes.name
  }

  get workSpaceTypeValue(): string {
    return this.attributes.work_space_type_value
  }

  get workSpaceTypeName(): string {
    return this.attributes.work_space_type_name
  }

  get capacity(): number {
    return this.attributes.capacity
  }

  get description(): string {
    return this.attributes.description
  }

  get start_time(): Date {
    return this.attributes.start_time
  }

  get end_time(): string {
    return this.attributes.end_time
  }

  get slot_setup(): string {
    return this.attributes.slot_setup
  }

  get multiple_bookings(): boolean {
    return this.attributes.allow_multiple_bookings
  }

  get slot_duration(): string {
    return this.attributes.slot_duration
  }
}

export default WorkSpace
